<template>
  <div v-show="isActive" class="tabcontent">
    <div @click="closeTabs()" class="close-btn">
      &times;
    </div>

    <slot></slot>

    <div v-if="! this.isLast" class="mt-4">
      <button
          class="bg-yellow-200 blob cursor-pointer border-0 w-full flex hover:bg-yellow-300 hover:scale-105 justify-center p-2 md:p-4 rounded text-yellow-800 transform transition-all"
          @click="$parent.nextTab()">
        <div class="h-6 leading-6">
          Volgende stap
        </div>
        <svg class="w-6 h-6 ml-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
        </svg>
      </button>
      <a @click="$parent.lastTab()"
         class="no-underline flex items-center no-underline text-center text-white txt-center my-4 cursor-pointer hidden md:block">
        Bestel direct
      </a>
    </div>
    <div v-else>
      <a id="add-to-cart" v-bind:href="$root.addToCartUrl"
              class="no-underline bg-yellow-200 blob w-full border-0 cursor-pointer flex hover:bg-yellow-300 hover:scale-105 justify-center p-2 md:p-4 rounded text-yellow-800 transform transition-all">
        <div class="h-6 leading-6">
          Toevoegen aan winkelwagen
        </div>
        <svg class="w-6 h-6 ml-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {required: true},
    default: {required: false, default: false},
    isLast: {default: false},
    selected: {default: false},
    icon: {default: null},
    svg: {default: null}
  },

  methods: {
    closeTabs() {
      window.bus.$emit('close-tabs')
    },

    addToCart() {
      window.bus.$emit('add-to-cart');
    },
  },

  data() {
    return {
      isActive: false,
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    href() {
      return '#' + this.name.toLowerCase().replace(/ /g, '-');
    }
  },

  mounted() {
    this.isActive = this.selected;

    if (this.default && this.windowWidth > 480) {
      this.isActive = true;
    }
  },
}
</script>

<style scoped lang="scss">
@import 'resources/assets/sass/_variables';
inherit
.tabcontent {
  border-top: 1px solid rgb(7, 132, 98);
  /*box-shadow: 0 0 10px 10px rgba(6, 214, 160, 0.4);*/
}

.button:hover {
  transform: scale(1.05);
}

.blob {
  box-shadow: 0 0 0 0 $secondary;
  animation: pulse-black 2s infinite;
}

@keyframes pulse-black {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

@media (min-width: 640px) {
  .tabcontent {
    border-top: none;
  }
}
</style>